import { loginRequest } from "../components/auth/authConfig.js";
import { hikoAlert } from "../utils/HikoAlert.js";


const env = process.env.REACT_APP_ENV;
const envConfig = require(`../config/config.${env}.json`);

/**
 * 
 * @param {object} mahiContext 
 * @param {string} bffPath 
 * @param {function} loadingSetter 
 * @param {function} stateSetter 
 * @param {object} queryParams 
 * @param {object} options 
 * @param {string} errorMessage 
 * @returns {boolean} True if the fetch succeeded, otherwise shows a hikoAlert and returns false.
 */
export const asyncFetchMahiBff = async (mahiContext, bffPath, loadingSetter, stateSetter, queryParams = {}, options = {method: 'GET'}, errorMessage = 'Problem loading data') => {
    let succeeded = true
    loadingSetter(true)
    try {
        const response = await fetchJSONWithAuth(mahiContext, 'bffMahi', bffPath, queryParams, options);
        stateSetter(response)
    } catch {
        hikoAlert(errorMessage, `We could not load data from ${bffPath}.`)
        succeeded = false
    } finally {
        loadingSetter(false)
    }
    return succeeded
}

/**
 * 
 * @param {object} mahiContext - {msal: {object}, mahiToken: {string|null}, acquireMahiToken: {function}}
 * @param {sting} protectedOrUnprotectedApi - api identifier from your config. E.g. 'bffMahi' or 'bffAzure'. If API is trusted id token is sent in headers.
 * @param {string} path - location of endpoint within your api. E.g. '/bff/axos-jde-billing-service/api/progress'.
 * @param {object} queryParams - GET parameters e.g. { 'filename': fileName }
 * @param {object} options - Fetch options. E.g. { method: 'GET', headers: {} }
 * @param {object} abortSignal - object of type AbortSignal
 * @returns {object} JSON object returned by your web endpont. Else throws an Error.
 */
export const fetchJSONWithAuth = async (mahiContext, protectedOrUnprotectedApi, path, queryParams, options, abortSignal = null) => {
    return await fetchJSONWithAuthSimplified(mahiContext, protectedOrUnprotectedApi, path, queryParams, options, abortSignal)
}

// const oldUnusedFetchJSONWithAuth = async (mahiContext, protectedOrUnprotectedApi, path, queryParams, options, abortSignal = null) => {
//     //
//     // Looks up protectedOrUnprotectedApi base url in config.{env}.json.
//     // For protected apis, adds the Azure AD access token to request headers before fetching {base}/path with options.
//     // For unprotected apis simply fetches {base}/path with options without adding the auth token to the request header.
//     //
//     let base, isAzureIdTokenApi = false, isMahiTokenApi = false;

//     console.log('fetchJSONWithAuth', options.method, protectedOrUnprotectedApi, path)
//     if (envConfig.apisTrustedWithMahiToken[protectedOrUnprotectedApi]) {
//         base = envConfig.apisTrustedWithMahiToken[protectedOrUnprotectedApi];
//         isMahiTokenApi = true;
//     } else if (envConfig.apisTrustedWithAzureIdToken[protectedOrUnprotectedApi]) {
//         base = envConfig.apisTrustedWithAzureIdToken[protectedOrUnprotectedApi];
//         isAzureIdTokenApi = true;
//     } else if (envConfig.unprotectedApis[protectedOrUnprotectedApi]) {
//         base = envConfig.unprotectedApis[protectedOrUnprotectedApi];
//     }
//     console.log('fetchJSONWithAuth isMahiTokenApi', isMahiTokenApi)
//     console.log('fetchJSONWithAuth isAzureIdTokenApi', isAzureIdTokenApi)

//     if (!base) {
//         const msg = `Failed to find ${protectedOrUnprotectedApi} in environment configuration.`;
//         throw new Error(msg);
//     }

//     const url = new URL(base + path);
//     if (queryParams) {
//         url.search = new URLSearchParams(queryParams);
//     }

//     if (isMahiTokenApi) {
//         options = await addMahiTokenAuth(mahiContext, options)
//     } else if (isAzureIdTokenApi) {
//         options = await addAzureIdTokenAuth(mahiContext, options)
//     }
//     options = addHeaders(options, { Accept: 'application/json' })
//     if (options.method === 'POST' || options.method === 'PUT') {
//         if (options.headers && !options.headers.hasOwnProperty('Content-Type')) {
//             //
//             // If the caller hasn't set the content type use 'application/json'
//             //
//             // console.log('fetchJSONWithAuth setting content-type to application/json', options)
//             options = addHeaders(options, { 'Content-Type': 'application/json' })
//         }
//     }
//     if (abortSignal) {
//         // caller wants to be able to AbortController.abort() the fetch below to trigger an AbortError
//         options.signal = abortSignal
//     }
//     console.log('fetchJSONWithAuth fetching url, options', url.toString(), options)

//     let response
//     try {
//         response = await fetch(url.toString(), options);
//     } catch (error) {
// 		if (error.name === "AbortError") { // should never happen if abortSignal is null
//             //
//             // fetch was aborted, e.g. by user navigating to another page
//             //
// 			console.error("fetchJSONWithAuth was aborted")
//             return ''
// 		} else {
// 			throw error;
// 		}
//     }

//     if (response.status === 204) {
//         //
//         // Success but no data!
//         //
//         return ''
//     }

//     if (response.status === 401 ) {
//         //
//         // We got a 401 Unauthorized
//         // Delete our mahi token so the app if forced to refresh it.
//         //
//         console.error('Mahi BFF gave 401. Deleting mahi token from localStorage.')
//         storeMahiTokenString(null)
//     }

//     let responseData = await response.json();

//     if (response.status >= 300) {
//         let msg = `Fetch error at ${url.toString()}.`;
//         if (responseData) {
//             if (responseData.message) {
//                 msg = `Response message: ${responseData.message}`;
//             } else if (responseData.Status === 'Error' && responseData.Type && responseData.Message) {
//                 //
//                 // This is the error object returned by e.g. the Oracle Wrapper.
//                 // { Status: 'Error', Type: 'System', Message: 'Foo bar baz' }
//                 //
//                 msg = `Response Type: ${responseData.Type}, Message: ${responseData.Message}`;
//             }
//         } else {
//             msg += ` Response: ${JSON.stringify(response)}`;
//         }
//         console.error('MahiAPI: ' + msg, response, responseData);
//         throw new Error(msg);
//     }

//     return responseData;
// };

/**
 * 
 * @param {object} mahiContext - {msal: {object}, mahiToken: {string|null}, acquireMahiToken: {function}}
 * @param {sting} protectedOrUnprotectedApi - api identifier from your config. E.g. 'bffMahi' or 'bffAzure'. If API is trusted id token is sent in headers.
 * @param {string} path - location of endpoint within your api. E.g. '/bff/axos-jde-billing-service/api/progress'.
 * @param {object} queryParams - GET parameters e.g. { 'filename': fileName }
 * @param {object} options - Fetch options. E.g. { method: 'GET', headers: {} }
 * @param {object} abortSignal - object of type AbortSignal
 * @returns {object} JSON object returned by your web endpont. Else throws an Error.
 */
const fetchJSONWithAuthSimplified = async (mahiContext, protectedOrUnprotectedApi, path, queryParams, options, abortSignal = null) => {
    //
    // Looks up protectedOrUnprotectedApi base url in config.{env}.json.
    // For protected apis, adds the Azure AD access token to request headers before fetching {base}/path with options.
    // For unprotected apis simply fetches {base}/path with options without adding the auth token to the request header.
    //
    let base, isAzureIdTokenApi = false, isMahiTokenApi = false;

    // console.log('fetchJSONWithAuthSimplified', options.method, protectedOrUnprotectedApi, path)
    if (envConfig.apisTrustedWithMahiToken[protectedOrUnprotectedApi]) {
        base = envConfig.apisTrustedWithMahiToken[protectedOrUnprotectedApi];
        isMahiTokenApi = true;
    } else if (envConfig.apisTrustedWithAzureIdToken[protectedOrUnprotectedApi]) {
        base = envConfig.apisTrustedWithAzureIdToken[protectedOrUnprotectedApi];
        isAzureIdTokenApi = true;
    } else if (envConfig.unprotectedApis[protectedOrUnprotectedApi]) {
        base = envConfig.unprotectedApis[protectedOrUnprotectedApi];
    }
    // console.log('fetchJSONWithAuthSimplified isMahiTokenApi', isMahiTokenApi)
    // console.log('fetchJSONWithAuthSimplified isAzureIdTokenApi', isAzureIdTokenApi)

    if (!base) {
        const msg = `Failed to find ${protectedOrUnprotectedApi} in environment configuration.`;
        throw new Error(msg);
    }

    const url = new URL(base + path);
    if (queryParams) {
        url.search = new URLSearchParams(queryParams);
    }

    if (isMahiTokenApi) {
        options = await addMahiTokenAuthSimplified(mahiContext, options)
    } else if (isAzureIdTokenApi) {
        options = await addAzureIdTokenAuth(mahiContext, options) // This may call acquireTokenSilent. It won't redirect to Azure AD B2C login page though.
    }
    options = addHeaders(options, { Accept: 'application/json' })
    if (options.method === 'POST' || options.method === 'PUT' || options.method === 'PATCH') {
        if (options.headers && !options.headers.hasOwnProperty('Content-Type')) {
            //
            // If the caller hasn't set the content type use 'application/json'
            //
            // console.log('fetchJSONWithAuthSimplified setting content-type to application/json', options)
            options = addHeaders(options, { 'Content-Type': 'application/json' })
        }
    }
    if (abortSignal) {
        // caller wants to be able to AbortController.abort() the fetch below to trigger an AbortError
        options.signal = abortSignal
    }
    // console.log('fetchJSONWithAuthSimplified fetching url, options', url.toString(), options)

    let response
    try {
        response = await fetch(url.toString(), options);
    } catch (error) {
		if (error.name === "AbortError") { // should never happen if abortSignal is null
            //
            // fetch was aborted, e.g. by user navigating to another page
            //
			console.error("fetchJSONWithAuthSimplified was aborted")
            return ''
		} else {
			throw error;
		}
    }

    if (response.status === 204) {
        //
        // Success but no data!
        //
        return ''
    }

    if (response.status === 401 ) {
        //
        // We got a 401 Unauthorized
        // Delete our mahi token so the app if forced to refresh it.
        //
        const msg = 'Session expired. Hit refresh or log out and log in again'
        console.error(msg)
        throw new Error(msg)
    }

    let responseData = await response.json();

    if (response.status >= 300) {
        let msg = `Fetch error at ${url.toString()}.`;
        if (responseData) {
            if (responseData.message) {
                msg = `Response message: ${responseData.message}`;
            } else if (responseData.Status === 'Error' && responseData.Type && responseData.Message) {
                //
                // This is the error object returned by e.g. the Oracle Wrapper.
                // { Status: 'Error', Type: 'System', Message: 'Foo bar baz' }
                //
                msg = `Response Type: ${responseData.Type}, Message: ${responseData.Message}`;
            }
        } else {
            msg += ` Response: ${JSON.stringify(response)}`;
        }
        console.error('MahiAPI: ' + msg, response, responseData);
        throw new Error(msg);
    }

    return responseData;
}

/**
 * 
 * @param {object} mahiContext - {msal: {object}, mahiToken: {string|null}, acquireMahiToken: {function}}
 * @param {string} oracleStoredProcedure - e.g. 'dms_Management_package.getJobList'
 * @param {object} body - e.g. {someField: 'some value'}
 * @param {object} abortSignal - object of type AbortSignal
 * @returns {object} JSON object returned by POST request to oracleStoredProcedure including JSON stringified body as payload.
 *                   Throws exception if a non-JSON result is returned or if no body is found in JSON response.
 */
export const postOracleWrapperJSONWithAuth = async (mahiContext, oracleStoredProcedure, body, abortSignal = null) => {

    const options = {
        method: 'POST',
        headers: {
            // 'Content-Type': 'application/json', // now done by fetchJSONWithAuth
        },
        body: JSON.stringify(body),
    };
    const oracleBase = '/bff/np-oracle-wrapper/api/nporacle/';
    const bffPath = oracleBase + oracleStoredProcedure;
    const queryParams = {};
    const response = await fetchJSONWithAuth(mahiContext, 'bffMahi', bffPath, queryParams, options, abortSignal);

    // console.log('postOracleWrapperJSONWithAuth response', response);

    if (!response) {
        console.error(`postOracleWrapperJSONWithAuth fetch to ${bffPath} was cancelled`)
        return ''
    }

    //
    // Some Oracle endpoints return an object { header, body }, others just return plain old JSON.
    // Scott is moving away from the { header, body } which was (maybe?) needed for Azure Service Bus.
    // In this function we accept either type of response, making the assumption that response.body
    // contains plain old JSON.
    // To indicate an error Scott's plain old JSON object takes the form { Status: 'Error', Type, Message; 'blah blah' }
    //
    let plainOldJson = response;
    if (response.body) {
        plainOldJson = response.body;
    }

    if (plainOldJson.Status === 'Error' && plainOldJson.Type && plainOldJson.Message) {
        //
        // Most likely an error from the Oracle stored procedure itself.
        //
        throw new Error(`Oracle ${plainOldJson.Type} Error. Message: ${plainOldJson.Message}`);
    }

    return plainOldJson;
}

/**
 * 
 * @param {object} mahiContext - {msal: {object}, mahiToken: {string|null}, acquireMahiToken: {function}}
 * @param {string} protectedOrUnprotectedApi - api identifier from your config. E.g. 'bffMahi' or 'bffAzure'. If API is trusted id token is sent in headers.
 * @param {string} path - location of endpoint within your api. E.g. '/bff/axos-jde-billing-service/api/progress'.
 * @param {object} file Javascript File object (See: https://developer.mozilla.org/en-US/docs/Web/API/File)
 * @param {object} options - Fetch options. E.g. { method: 'GET', headers: {} }
 * @param {object} abortSignal - object of type AbortSignal
 * @returns {object} JSON object returned by your web endpoint. E.g. {
 *   "fileKey":"0000571486NRE5C/00017684/as-builts/20220804.090007.blue-sun-burst.jpg",
 *   "url":"https://mahi-test.northpower.com/bff/icp-livening-service/api/new-connections/as-builts/get-document?fileKey=0000571486NRE5C%2F00017684%2Fas-builts%2F20220804.090007.blue-sun-burst.jpg&token=eyJhbGciOiZjAGpcw"
 * }
 */
export const putMultipartFormDataWithAuth = async (mahiContext, protectedOrUnprotectedApi, path, file, options, abortSignal = null) => {
    let base;

    // console.log('putMultipartFormDataWithAuth', options.method, protectedOrUnprotectedApi, path)
    if (envConfig.apisTrustedWithMahiToken[protectedOrUnprotectedApi]) {
        base = envConfig.apisTrustedWithMahiToken[protectedOrUnprotectedApi];
    }

    if (!base) {
        const msg = `${protectedOrUnprotectedApi} is not trusted for form data upload.`;
        throw new Error(msg);
    }

    const url = new URL(base + path);

    if (!options.method) {
        options.method = 'PUT' // Default method is put
    }
    if (!['PUT', 'POST'].includes(options.method)) {
        const msg = `Multipart form data method must be PUT or POST.`;
        throw new Error(msg);
    }

    options = await addMahiTokenAuth(mahiContext, options)
    options = addHeaders(options, { Accept: 'application/json' }) 

    const formData = new FormData();
    formData.append('file', file, file.name); // file is a Javascript File (https://developer.mozilla.org/en-US/docs/Web/API/File)

    options.body = formData

    if (abortSignal) {
        // caller wants to be able to AbortController.abort() the fetch below to trigger an AbortError
        options.signal = abortSignal
    }
    // console.log('putMultipartFormDataWithAuth fetching url, options', url.toString(), options)

    let response
    try {
        response = await fetch(url.toString(), options);
    } catch (error) {
		if (error.name === "AbortError") { // should never happen if abortSignal is null
            //
            // fetch was aborted, e.g. by user navigating to another page
            //
			console.error("putMultipartFormDataWithAuth was aborted")
            return ''
		} else {
			throw error;
		}
    }

    // if (response.status === 401 ) {
    //     //
    //     // We got a 401 Unauthorized
    //     // Delete our mahi token so the app if forced to refresh it.
    //     //
    //     // Also abort other in-flight fetches?
    //     //
    //     console.error('Mahi Multipart Form upload gave 401. Deleting mahi token from localStorage.')
    //     storeMahiTokenString(null)
    // }

    let responseData = await response.json();

    if (response.status >= 300) {
        let msg = `Fetch error in multipart form at ${url.toString()}.`;
        if (responseData) {
            if (responseData.message) {
                msg += ` Response message: ${responseData.message}`;
            } else if (responseData.Status === 'Error' && responseData.Type && responseData.Message) {
                //
                // This is the error object returned by e.g. the Oracle Wrapper.
                // { Status: 'Error', Type: 'System', Message: 'Foo bar baz' }
                //
                msg += ` Type: ${responseData.Type}, Message: ${responseData.Message}`;
            }
        } else {
            msg += ` Response: ${JSON.stringify(response)}`;
        }
        console.error('MahiAPI: ' + msg, response, responseData);
        throw new Error(msg);
    }

    return responseData;
}

const addAzureIdTokenAuth = async (mahiContext, options) => {
    let result = options;
    //
    // Get id token and add it as Authorization header in options.
    //
    const idToken = await acquireAzureIdToken(mahiContext.msal.instance)
    if (idToken) {
        const newHeader = {
            Authorization: `Bearer ${idToken}`,
        }
        result = addHeaders(options, newHeader);
    } else {
        console.error('No bearer token added by addAzureIdTokenAuth')
    }
    return result;
}

const acquireAzureIdToken = async (theMsalInstance) => {
    const authResult = await acquireAzureIdTokenResponse(theMsalInstance);
    return (authResult && authResult.idToken);
};

const acquireAzureIdTokenResponse = async (theMsalInstance) => {
    const activeAccount = theMsalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
    const accounts = theMsalInstance.getAllAccounts();

    if (!activeAccount && accounts.length === 0) {
        /*
        * User is not signed in. Throw error or wait for user to login.
        * Do not attempt to log a user in outside of the context of MsalProvider
        */   
       console.error('User is not signed in!');
       return null;
    }

    // This code is recommended here: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/FAQ.md#how-do-i-handle-the-redirect-flow-in-a-react-app
    // but doesn't really fit in this context because we don't have isAuthenticated or inProgress
    // if (!isAuthenticated || inProgress !== InteractionStatus.None) {
    //    console.error('User login is in progress!')
    //    return null
    // }

    const request = {
        // scopes: ["User.Read"],
        scopes: loginRequest.scopes,
        account: activeAccount || accounts[0], // Mick Temp: may choose the wrong account if user is logged in multiple times. See: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/accounts.md
        forceRefresh: true, // Ensures Id token is refreshed. Not needed if we go back to using access tokens. See: https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/1241
    };

    let authResult;
    //
    // See: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/acquire-token.md
    // For redirect flow see also: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/FAQ.md#how-do-i-handle-the-redirect-flow-in-a-react-app
    //
    try {
        // console.log('acquireAzureIdTokenResponse trying theMsalInstance.acquireTokenSilent'); 
        authResult = await theMsalInstance.acquireTokenSilent(request);
    } catch (error) {
        console.error('acquireTokenSilent threw an error. User is most likely logged out.')
        throw error
        //     if (error instanceof InteractionRequiredAuthError) {
        //         // Might be nice to implement this but we need to make sure the redirect comes back to the current page.
        //         console.error('acquireAzureIdTokenResponse could not acquire token silent - logging in via acquireTokenRedirect');
        //         await theMsalInstance.acquireTokenRedirect(request);
        //     } else {
        //         console.error('acquireTokenSilent threw an error. User is most likely logged out.')
        //         throw error
        //     }
    }

    return authResult;
};

const addMahiTokenAuth = async (mahiContext, options) => {
    return await addMahiTokenAuthSimplified(mahiContext, options)
}

const addMahiTokenAuthSimplified = async (mahiContext, options) => {
    let newOptions = options
    // console.log('addMahiTokenAuthSimplified about to check mahiTokenString')
    const mahiTokenString = mahiContext.mahiTokenString
    if (mahiTokenString) {
        // console.log('addMahiTokenAuthSimplified adding Mahi token to auth header')
        const newHeader = {
            Authorization: `Bearer ${mahiTokenString}`,
        }
        newOptions = addHeaders(newOptions, newHeader); // Will overwrite any existing Authorization property
    } else {
        console.error('No bearer token added by addMahiTokenAuthSimplified')
    }
    return newOptions;
}

function addHeaders(options, newHeaders) {
    const update = { ...options };
    update.headers = {
        ...update.headers,
        ...newHeaders,
    };
    return update;
}



/**
 * 
 * @returns {string|null} JSON stringified hiko token retrieved from user management service or null if no token found.
 * Suppresses exceptions and returns null.
 * The call to fetchJSONWithAuth() using 'bffAzure' below is the only place
 * in the whole codebase that we call acquireTokenSilent to refresh Azure AD Tokens.
 * 
 */
export async function postAdminLogin(mahiContext) {
    // console.log('postAdminLogin started');

    const options = {
        method: 'POST',
        headers: {
        },
    };
    const bffPath = '/bff/user-management-service-mahi/api/auth/login';
    const queryParams = {
    }

    let response = null
    try {
        //
        // Must use the bffAzure route guard here. We may not yet have a hiko token so can't use bffMahi.
        // We are using our Azure AD token to log into user management
        // service which gives us a Mahi Token in response.
        //
        response = await fetchJSONWithAuth(mahiContext, 'bffAzure', bffPath, queryParams, options);
    } catch (e) {
        console.error('Failed to log in to user management service')
        response = null
    }
    // console.log('postAdminLogin response', response);
    return (response ? response.MahiToken : null);
}

// /**
//  * 
//  * @returns {object} {message, object, payload} indicating login status at bff
//  */
// export async function oldUnusedGetValidateMahiToken(mahiContext) {
//     console.log('getValidateMahiToken started')

//     const options = {
//         method: 'GET',
//         headers: {
//         },
//     }
//     const bffPath = '/bff/validate-mahi-token';
//     const queryParams = {
//     }

//     let response = null
//     try {
//         response = await fetchJSONWithAuth(mahiContext, 'bffMahi', bffPath, queryParams, options)
//     } catch (e) {
//         console.error('Failed to validate mahi token')
//         response = null
//     }
//     console.log('getValidateMahiToken response', response)
//     return (response ? response.payload : null)
// }

/**
 * 
 * @returns {string} Base url for Hiko Bff in the current environment e.g. 'https://hiko-test.northpower.com'
 */
export const mahiBffUrl = () => {
    return envConfig.apisTrustedWithMahiToken['bffMahi']
}


/**
 * 
 * @returns {object} {message, object, payload} indicating login status at bff
 */
export async function getValidateMahiTokenSimplified(mahiContext) {
    // console.log('getValidateMahiTokenSimplified started')

    const options = {
        method: 'GET',
        headers: {
        },
    }
    const bffPath = '/bff/validate-mahi-token';
    const queryParams = {
    }

    let response = null
    try {
        response = await fetchJSONWithAuthSimplified(mahiContext, 'bffMahi', bffPath, queryParams, options)
    } catch (e) {
        console.error('Failed to validate mahi token')
        response = null
    }
    // console.log('getValidateMahiTokenSimplified response', response)
    return (response ? response.payload : null)
}